// @ts-nocheck
import {useEffect} from "react";
import {getBrandTitleByHostname} from "../util/logoUtils";

/**
 * Updates a meta tag with the specified name and content
 * @param {string} name - The name attribute of the meta tag
 * @param {string} content - The content for the meta tag
 */
const updateMetaTag = (name, content) => {
  let metaTag = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`);

  if (!metaTag) {
    metaTag = document.createElement("meta");
    if (name.startsWith("og:") || name.startsWith("twitter:")) {
      metaTag.setAttribute("property", name);
    } else {
      metaTag.setAttribute("name", name);
    }
    document.head.appendChild(metaTag);
  }

  metaTag.setAttribute("content", content);
};

/**
 * Custom hook to set the document title and meta tags dynamically based on hostname
 * @param {string} pageSuffix - Optional suffix to append to the brand title (e.g., " - Home")
 * @param {string} description - Optional custom description for the page
 */
export const useDynamicTitle = (pageSuffix = "", description = "") => {
  useEffect(() => {
    const brandTitle = getBrandTitleByHostname();
    const fullTitle = pageSuffix
      ? `${brandTitle}${pageSuffix}`
      : `${brandTitle} - Donde el ganador eres tu! - Tu plataforma de apuestas en linea`;

    const defaultDescription =
      description ||
      `${brandTitle} - Tu plataforma de apuestas en línea donde el ganador eres tú. Juega y gana con nosotros.`;

    // Update document title
    document.title = fullTitle;

    // Update meta tags for better SEO and social sharing (client-side only)
    updateMetaTag("description", defaultDescription);
    updateMetaTag("og:title", fullTitle);
    updateMetaTag("og:description", defaultDescription);
    updateMetaTag("twitter:title", fullTitle);
    updateMetaTag("twitter:description", defaultDescription);
    updateMetaTag("og:site_name", brandTitle);
  }, [pageSuffix, description]);
};

/**
 * Component that sets the document title and meta tags based on hostname
 * This component should be included once at the app root level
 */
export const DynamicTitleProvider = ({children}) => {
  useDynamicTitle();

  return children;
};
